import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Projects from './pages/Projects';
import ProjectFloorPlan from './pages/ProjectFloorPlan';
import Devices from './pages/Devices';
import PlayerControls from './pages/PlayerControls';
import ControlPanel from './pages/ControlPanel';
import ProtectedRoute from './components/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';

function HomeRedirect() {
  const token = localStorage.getItem('adminToken');
  const { user } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  const isAdmin = user?.role === 'admin';
  return <Navigate to={isAdmin ? '/dashboard' : '/control-panel'} replace />;
}

function App() {
  return (
    <ThemeProvider>
    <Router>
      <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Projects />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/floorplan"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <ProjectFloorPlan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/devices"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Devices />
            </ProtectedRoute>
          }
        />
        <Route
          path="/player-controls"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <PlayerControls />
            </ProtectedRoute>
          }
        />
        <Route
          path="/control-panel"
          element={
            <ProtectedRoute>
              <ErrorBoundary>
                <ControlPanel />
              </ErrorBoundary>
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<HomeRedirect />} />
      </Routes>
      </AuthProvider>
    </Router>
    </ThemeProvider>
  );
}

export default App;
